import { useLocation } from 'react-router-dom'

import { popupStatus } from '@sportworld/js-sdk/src/constants/popup'

import { paths } from '@/constants/paths'
import useStore from '@/store/useStore'

export const useCanShowUcPopup = (hasDefaultLabels: boolean) => {
  const { pathname } = useLocation()
  const usercentricsPopup = useStore((state) => state.common.usercentricsPopup)
  const currentEvent = useStore((state) => state.common.currentEvent)
  const listPopup = useStore((state) => state.common.listPopup)
  const mediaVideo = useStore((state) => state.common.mediaVideo)
  const { pagePopupStatus } = useStore((state) => state.popup)
  const { isFullscreen } = useStore((state) => state.player)

  const allowedPaths = [
    paths.HOME,
    paths.CLASSIC_HOME,
    paths.SPECIAL_HOME,
    paths.FEATURE_SCREEN,
  ]
  const isAllowedPath = allowedPaths.includes(pathname)

  const isPagePopupOpen = pagePopupStatus !== popupStatus.CLOSED
  const hasPopup =
    isFullscreen || mediaVideo || listPopup || currentEvent || isPagePopupOpen
  const isBasePage = isAllowedPath && !hasPopup
  const isCookieBannerPage = pathname.includes(paths.SETTINGS_COOKIE_BANNER)

  return (
    usercentricsPopup && hasDefaultLabels && (isBasePage || isCookieBannerPage)
  )
}
